import React, { FC } from 'react';
import { CustomAutocompleteProps } from './CustomAutocompleteProps';
import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';
import { BusinessUnit } from '../../models/buniessUnitType';
import { returnDisabledStatus } from '../../utils/fieldEditingRules';

const CustomAutocomplete: FC<CustomAutocompleteProps> = ({
  optionsArray,
  name,
  label,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  customOnChange = (value: any) => {
    // do nothing
  },
  disabled = false,
  required = false,
}) => {
  const { control, watch } = useFormContext();
  const disabledFields = watch('disabledFields');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
        const selectedOption =
          optionsArray.find((option) => option.businessUnitId === value) ||
          null;

        return (
          <Autocomplete
            options={optionsArray}
            disabled={
              disabled ||
              !optionsArray?.length ||
              returnDisabledStatus(disabledFields, name)
            }
            data-testid={'bu-selector'}
            getOptionLabel={(option: BusinessUnit) =>
              `${option.businessUnitFullName}`
            }
            isOptionEqualToValue={(option, value) =>
              option.businessUnitId === value.businessUnitId
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                inputRef={ref}
                error={!!error}
                helperText={error ? error.message : null}
                required={required}
                disabled={disabled}
              />
            )}
            value={selectedOption}
            onChange={(_, data: BusinessUnit | null) => {
              if (data) {
                onChange(data.businessUnitId);
                customOnChange(data);
              } else {
                onChange('');
              }
            }}
          />
        );
      }}
    />
  );
};

export default CustomAutocomplete;
